import { render } from "./MrEditRoomRegularlyReservationModal.vue?vue&type=template&id=b8fcbca0&ts=true"
import script from "./MrEditRoomRegularlyReservationModal.vue?vue&type=script&lang=ts"
export * from "./MrEditRoomRegularlyReservationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__